const apiBase = () => {
    if (process.env.NODE_ENV === 'development')
        return 'http://localhost:5273/api';
    return '/api';
};

export const apiBaseUrl = apiBase();

// PÄÄSIVU
export const homeUrl = '/';